<script lang="ts">
  import { onMount } from "svelte";
  import { fallbackDatepicker } from './Util/utils';


  export let label: string = undefined;
  export let placeholder: string = undefined;
  export let units: string = undefined;
  export let type: string = "number";
  export let enabled: boolean = true;
  export let min = undefined;
  export let step = undefined;
  export let required = false;

  export let validate: ((any)=>void) = (event)=>event.target.value;

  export let input;
  export let output = undefined;

  let element;
  onMount(()=>{
    // Use jQuery date/time picker for Safari.
    if (type == "date")
      fallbackDatepicker(element);

  });

</script>

<span>{label}</span>
<div style={units != null ? `--units: "${units}"` : ''}>
{#if enabled}
  {#if type=="number"}
  <input type="number" {min} {step} maxlength="{256}" on:input={validate} {placeholder} bind:value={output} {required}/>
  {:else}
  <input bind:this={element} {type} {min} {step} maxlength="{256}" on:input={(event)=>output=validate(event)} {placeholder} value={input} {required}/>
  {/if}
{:else}
<input value={input} disabled/>
{/if}
</div>

<style lang="scss">
  div {
    position: relative;
    width: 100%;
    &:before {
      content: var(--units);
      position: absolute;
      right: 6px;
      top: 50%;
      height: 0;
      line-height: 0;

      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      /* identical to box height */
      text-align: right;
      letter-spacing: 0.48px;

      color: #979797;
    }
  }

  input {
    margin: 0;
    width: 100%;
    // Use default color for disabled inputs to be readable.
    &:disabled {
      color: initial;
    }
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    &[type=number] {
      -moz-appearance: textfield;
    }
  }
</style>